import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=6eda31ff&scoped=true&"
import script from "./OrganizationInfo.vue?vue&type=script&lang=js&"
export * from "./OrganizationInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationInfo.vue?vue&type=style&index=0&id=6eda31ff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eda31ff",
  null
  
)

export default component.exports